export default {
  tier_0: 'Tier 0',
  tier_1: 'Tier 1',
  tier_2: 'Tier 2',
  tier_3: 'Tier 3',
  t3: 'T3', // Tier 3 - This is a mistake when we set Tier 3 on Prod
  tier_3_unverified: 'Tier 3 - Unverified Pilot',
}

/** Statsig dynamic config: returns { "merchant-tier": ["T2", "T3"] } or { "merchant-tier": [] } */
export const MERCHANT_CALLBACK_TIER_CONFIG = 'merchant_callback_tier_config'

/** Maps profile tier values to the short codes used by merchant_callback_tier_config */
export const MERCHANT_TIER_TO_CALLBACK_CODE = {
  'Tier 0': 'T0',
  T0: 'T0',
  'Tier 1': 'T1',
  T1: 'T1',
  'Tier 2': 'T2',
  T2: 'T2',
  'Tier 3': 'T3',
  T3: 'T3',
  'Tier 3 - Unverified Pilot': 'T3',
}
